import React from 'react';

/**
 * For URLs eg: https://na.vici.pars.amazon.dev/cpr?mons_redirect=sign_in#/caseDetails/1687189057455387?tab=2
 * we have to replace the search params.
 * @returns the formatted url or null if no replacement is needed
 */
export function cprFormattedLocation(): string | null {
  if (window.location.search.includes('?mons_redirect=sign_in')) {
    /**
     * origin: "https://na.vici.pars.amazon.dev"
     * pathname: /cpr
     * hash: #/caseDetails/1687189057455387?tab=2
     */
    const { origin, pathname, hash } = window.location;
    return `${origin}${pathname}${hash}`;
  }
  return null;
}

/**
 * CprUrlFormattedRoute is a Higher Order Component to format the routes in case mons adds the redirect signin search param.
 * @param children the child nodes for the HOC.
 * @returns the child nodes and does the replacement of the URL if needed.
 */
const CprUrlFormattedRoute = ({ children }) => {
  const location = cprFormattedLocation();
  if (location) {
    window.location.replace(location);
  }
  return <>{children}</>;
};

export { CprUrlFormattedRoute };
